import React, { ReactElement } from 'react'
import './VideoStyles.scss'

import VideoLoader from './VideoLoader'
import fetchVideo from '../../api/fetchVideo'

export type Clip = {
  id: number
  videoName: string
  startTime: number
  endTime: number
  labels: Record<string, boolean>
  previousClip: Clip | null
}

export default function VideoPlayer({
  currentClip,
  videoRef,
  onTimeUpdate, // Function to call when time updates
}: {
  currentClip: Clip | null
  videoRef: React.RefObject<HTMLVideoElement>
  onTimeUpdate: (time: number) => void // Add this prop
}): ReactElement {
  const [stream, setStream] = React.useState<string>()
  const [isReady, setIsReady] = React.useState<boolean>(true)

  function onReady(): void {
    setIsReady(true)
  }

  React.useEffect(() => {
    async function fetchStream(): Promise<void> {
      if (currentClip) {
        setIsReady(false)
        setStream(await fetchVideo(currentClip))
      }
    }
    fetchStream()
  }, [currentClip])

  React.useEffect(() => {
    const videoElement = videoRef.current
    const handleTimeUpdate = (): void => {
      if (videoElement) {
        onTimeUpdate(videoElement.currentTime)
      }
    }

    videoElement?.addEventListener('timeupdate', handleTimeUpdate)

    return () => {
      videoElement?.removeEventListener('timeupdate', handleTimeUpdate)
    }
  }, [videoRef, onTimeUpdate])

  return (
    <div className="videoPlayer">
      <div className="reactPlayer">
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video
          hidden={!isReady}
          controls
          controlsList="nodownload"
          id="player"
          ref={videoRef}
          crossOrigin="use-credentials"
          width="100%"
          height="100%"
          preload="auto"
          src={stream}
          onLoadedData={onReady}
        />
      </div>
      <VideoLoader isReady={isReady} />
    </div>
  )
}
